import { eTitleSearchStatus } from './eTitleSearchStatus';

export interface ITitleSearchRequestResponse {
  titleSearchId: string;
  orderId: string;
  vendorCompanyId: string;
  status: eTitleSearchStatus;
  orderedByFullName: string | null;
  createdAt: string;
  updatedAt?: string;
}

export type ITitleSearchRequestData = ITitleSearchRequestResponse;

export const convertFromTitleSearchRequestResponseToTitleSearchRequestData = (
  data: ITitleSearchRequestResponse
): ITitleSearchRequestData => data;
export const convertFromTitleSearchRequestDataToTitleSearchRequestResponse = (
  data: ITitleSearchRequestData
): ITitleSearchRequestResponse => data;

export const convertFromTitleSearchRequestResponseArrayToTitleSearchRequestDataArray = (
  data: ITitleSearchRequestResponse[]
): ITitleSearchRequestData[] => data;
export const convertFromTitleSearchRequestDataArrayToTitleSearchRequestResponseArray = (
  data: ITitleSearchRequestData[]
): ITitleSearchRequestResponse[] => data;
